const missionIdToVideoId = {
  1: '6a7dca9688bbabcd786e2eb4',
  2: '6a7dca9688bbabcd786e2eb2',
  3: '6a7dca9688bbabcd786e2e97',
  4: '6a7dca96c19d5bbff50d91be',
  5: '6a7dca96c19d5bbff50d91b2',
  6: '6a7dca96c19d5bbff50d91b8',
  7: '6a7dca96375db171e66410a0',
  8: '6a7dca9688bbabcd786e2ea6',
  9: '6a7dca9688bbabcd786e2e9d',
  10: '6a7edc61d37ebdbb33289a66',
  11: '6a7dca9688bbabcd786e2eaa'
};


// 1 - שמע / הצופן
// https://gumlet.tv/watch/6a7dca9688bbabcd786e2eb4/
// 2 - שפת הסימנים - טעמי המקרא
// https://gumlet.tv/watch/6a7dca9688bbabcd786e2eb2/
// 3 - אסנה סאנה - ברכות
// https://gumlet.tv/watch/6a7dca9688bbabcd786e2e97/
// 4 - ידיים למעלה - תפילה
// https://gumlet.tv/watch/6a7dca96c19d5bbff50d91be/
// 5 - לא סתם אי - סת"ם
// https://gumlet.tv/watch/6a7dca96c19d5bbff50d91b2/
// 6 - מקדש OL - בית כנסת
// https://gumlet.tv/watch/6a7dca96c19d5bbff50d91b8/
// 7 - אחלאח - נתינה/צדקה
// https://gumlet.tv/watch/6a7dca96375db171e66410a0/
// 8 - ת'ביך ו'תימך - כיבוד הורים
// https://gumlet.tv/watch/6a7dca9688bbabcd786e2ea6/
// 9 - מיגה דול - בגרות/מנהיגות
// https://gumlet.tv/watch/6a7dca9688bbabcd786e2e9d/
// 10 - אחריות גאולה (חסר)
// https://gumlet.tv/watch/6a7edc61d37ebdbb33289a66
// 11 - רצועה בריבוע - תפילין
// https://gumlet.tv/watch/6a7dca9688bbabcd786e2eaa/


const islandIdToVideoId = {
  1: '6a7dbe34c19d5bbff50c0801',
  2: '6a7dc38d88bbabcd786d4e4c',
  3: '6a7dc38d88bbabcd786d4e55',
  4: '6a7dc38d375db171e6632fc9',
  5: '6a7dc38d375db171e6632fcf',
  6: '6a7dc38dc19d5bbff50cae0c',
  7: '6a7dc38d88bbabcd786d4e5b',
  8: '6a7dc38dc19d5bbff50cae12',
  9: '6a7dc38dc19d5bbff50cae18',
  10: '6a82c9849b229770721ddf96',
  11: '6a7dc38d375db171e6632fd7'
};

export const getMissionVideoId = (missionId) => (
  missionIdToVideoId[Number(missionId)]
);

export const getIslandVideoId = (missionId) => (
  islandIdToVideoId[Number(missionId)]
);

export default missionIdToVideoId;
